import React from 'react'

//import { createStore, applyMiddleware } from 'redux'
//import { Provider } from 'react-redux'
//import thunkMiddleware from 'redux-thunk'
//import { createLogger } from 'redux-logger'
//import { composeWithDevTools } from 'redux-devtools-extension'

//import { bridgeProductManagementApp } from './GlobalStateContainer'
//import ProductManageReactApp from './ProductManageReactApp'

class MainMobileNav extends React.Component {
    constructor(props) {
        super(props);
    }

    renderMobileMenuItem = (menuItem, depth=0) => {
        const maxDepth = 2;
        let linkUrl = depth === 0 || (menuItem.Children && menuItem.Children.length > 0) ? "#" : menuItem.PageLinkUrl;


        if (!!(menuItem.Children && menuItem.Children.length > 0 && depth <= maxDepth)) {
            let locationItems = {};
            if (menuItem.IsAllLocationsPage) {
                for (let i = 0; i < menuItem.Children.length; i++) {
                    const location = menuItem.Children[i];
                    if (locationItems[location.GroupName] === undefined) {
                        locationItems[location.GroupName] = {
                            Title: location.GroupName,
                            PageLinkUrl: "#",
                            Children: []
                        };
                        locationItems[location.GroupName].Children.append(location);
                    }
                }
            }

            let subMenuItems = (menuItem.IsAllLocationsPage ? locationItems : menuItem.Children).map((submenuItem) => this.renderMobileMenuItem(submenuItem, depth + 1));

            return (
                <li key={menuItem.Title}>
                    <a href={linkUrl} target={menuItem.Target}>
                        {!!menuItem.FontAwesomeClass && <i className={"fa fa-" + menuItem.FontAwesomeClass}></i>}
                        <span className="main"> {menuItem.Title}</span>
                    </a>
                    <ul role="menu">
                        {subMenuItems}
                    </ul>
                </li>
            );
        } else {
            return (
                <li key={menuItem.Title}>
                    <a href={linkUrl} target={menuItem.Target}>
                        {!!menuItem.FontAwesomeClass && <i className={"fa fa-" + menuItem.FontAwesomeClass}></i>}
                        <span className="main">{menuItem.Title}</span>
                    </a>
                </li>
            );
        }
    }

    render() {
        const menuItems = this.props.menuItems.map((menuItem) => this.renderMobileMenuItem(menuItem, 0));

        return (
            <nav className="header-botom-top-wrapper navbar navbar-default yamm" role="navigation" style={{ border: "none", minHeight: "22px" }}>
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle mobile-nav-toggle" style={{ margin: 0, border: "none"}}>
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                </div>
                <div className="hidden-md hidden-lg mobile-nav-collapse">
                    <div id="mobile_menu" className="mobile-nav">
                        <ul className="flexnav">
                            {menuItems}
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default MainMobileNav
